import { IonCol, IonGrid, IonRow } from "@ionic/react";
import { URLS } from "../../urls";
import { getBonusPerPlayer, getScorePerPlayer } from "../../calcScore";
import React, { Component } from "react";
import "./style.css";

type MyProps = {
    data: any;
    userBets: any;
    userScores: any;
    tournamentID: string;
    showPlayers: boolean;
};

class Bets extends Component<MyProps> {
    state = {
        data: {} as any,
        tournamentID: this.props.tournamentID,
        showPlayers: this.props.showPlayers,
    };

    public static defaultProps = {
        showPlayers: false,
    };

    static getDerivedStateFromProps(props, current_state) {
        return {
            data: props.data,
            tournamentID: props.tournamentID,
            showPlayers: props.showPlayers,
        };
    }

    render() {
        var betsToShow: any = {};
        for (let key in this.props.userBets) {
            let bet = this.props.userBets[key];
            if (this.state.data.Games[bet.gameID]?.tournamentID == this.state.tournamentID)
                betsToShow[bet.gameID] = bet;
        }

        return (
            <div style={{ overflowX: "auto", paddingBottom: "10px" }}>
                {Object.keys(betsToShow).length !== 0 ? (
                    <IonGrid className="user__grid" key="table">
                        <IonRow>
                            <IonCol className="user__game-col">שם המחזור</IonCol>
                            {this.state.data.Positions.map((pos: any) => {
                                return Array.from(Array(parseInt(pos.needToChoose)).keys()).map(
                                    (posNum: any) => {
                                        return (
                                            <IonCol
                                                className="user__long-col"
                                                key={"role" + pos.description + posNum}
                                            >
                                                {pos.description +
                                                    (parseInt(pos.needToChoose) === 1
                                                        ? ""
                                                        : " " + (posNum + 1))}
                                            </IonCol>
                                        );
                                    }
                                );
                            })}
                            <IonCol className="user__score-col">סה"כ</IonCol>
                        </IonRow>
                        {Object.values(betsToShow).map((gameBet: any) => {
                            let gameScore = this.props.userScores[gameBet.gameID]?.score ?? 0;
                            return (
                                <IonRow key={"game" + gameBet.gameID}>
                                    <IonCol className="user__game-col">
                                        <div>
                                            <span className="user__long-colspan-centerer" />
                                            <span className="user__long-colspan-centered">
                                                {this.state.data.Games[gameBet.gameID].description}
                                            </span>
                                        </div>
                                    </IonCol>
                                    {gameBet.choice.map((playerNumber: any) => {
                                        let playerScore = getScorePerPlayer(
                                            this.state.data,
                                            gameBet.gameID,
                                            playerNumber
                                        );
                                        let playerBonus = getBonusPerPlayer(
                                            this.state.data,
                                            gameBet.gameID,
                                            playerNumber
                                        );
                                        let player = this.state.data.Players[playerNumber];
                                        if (!player)
                                            console.log("Player " + playerNumber + " does not exist!!!");

                                        return (
                                            <IonCol key={"name" + playerNumber} className="user__colspan">
                                                {this.state.showPlayers ? (
                                                    <div>
                                                        <a
                                                            href={URLS.PLAYER.url + "/" + playerNumber}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                        >
                                                            <div className="user__long-colspan">
                                                                <span className="user__long-colspan-centerer" />
                                                                <span className="user__long-colspan-centered">
                                                                    {player?.playerName}
                                                                    <br />
                                                                    {
                                                                        this.state.data.Teams[
                                                                            player?.teamNumber
                                                                        ]?.teamName
                                                                    }
                                                                </span>
                                                            </div>
                                                        </a>
                                                        <div className="user__short-colspan">
                                                            {playerScore}
                                                            {playerBonus ? (
                                                                <span style={{ color: "greenyellow" }}>
                                                                    {" "}
                                                                    W
                                                                </span>
                                                            ) : (
                                                                ""
                                                            )}
                                                        </div>
                                                    </div>
                                                ) : (
                                                    ""
                                                )}
                                            </IonCol>
                                        );
                                    })}
                                    <IonCol className="user__score-col">
                                        <span className="user__long-colspan-centerer" />
                                        <span className="user__long-colspan-centered">{gameScore}</span>
                                    </IonCol>
                                </IonRow>
                            );
                        })}
                    </IonGrid>
                ) : (
                    ""
                )}
            </div>
        );
    }
}
export default Bets;
